<template>
    <div class="socialmedia-box">
        <!-- 行走的线 -->
        <div class="animetionLine"></div>
        <div class="center-box">
            <div class="itemleft">
                <h3 class="caption" >{{socialmediaData.leftData.caption}}</h3>
                <div class="center" v-html='socialmediaData.leftData.center'></div>
                <div class="imgbox" :style='{backgroundImage:"url("+socialmediaData.leftData.imgurl+")"}'></div>
            </div>
            <div class="itemright">
                <div class="imglogo-box" :style='{backgroundImage:"url("+socialmediaData.rightData.imgurl+")"}'></div>
                <div class="right-center">{{socialmediaData.rightData.center}}</div>
                <ul class="right-ul">
                    <li class="right-li" v-for='(item,index) in socialmediaData.rightData.listData' :key='index'>
                        <div class="number">{{item.number}}</div>
                        <div class="numbertitle">{{item.title}}</div>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        name: 'SocialMedia',
        data() {
            return {
                socialmediaData: {
                    leftData: {
                        caption: 'Social Media ',
                        center: '<p>您是否正在寻找一种有效的方法来提高企业的品牌知名度和网站流量？</p><p>然后，您应该在社交媒体上获取我们的社交媒体推广服务，并建立强大的社交媒体形象。</p>',
                        imgurl: 'https://lanjingshuziguanwang-public.oss-cn-hangzhou.aliyuncs.com/IMG/project/3666b04fe0e6e4c56eea83edda5c4b88.jpg'
                    },
                    rightData: {
                        imgurl: 'https://lanjingshuziguanwang-public.oss-cn-hangzhou.aliyuncs.com/IMG/project/speakerlogolinkedin.jpg',
                        center: '全球职场社交平台，是一家面向商业客户的社交网络用户数已超过6.75亿，覆盖全球 200 多个国家和地区',
                        listData: [
                            {
                                number: '6.75亿+',
                                title: '全球范围'
                            },
                            {
                                number: '1.25亿',
                                title: '亚太地区'
                            },
                            {
                                number: '4,900万+',
                                title: '中国'
                            }
                        ]
                    }
                }
            }
        }
    }
</script>
<style scoped>
    .socialmedia-box {
        margin: 175px 0 402px 0;
        background-color: #ffffff;
        position: relative;
    }

    .center-box {
        display: grid;
        grid-template-columns: 1fr 565px;
        grid-column-gap:46px;
        max-width:1484px;
        margin: 0 auto;
    }
    .itemleft{
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }
    .center{
        align-self: flex-start;
        padding-left: 5%;
    }

    .caption {
        font-size: 7.291vw;
        white-space: nowrap;
        font-family: gilroybold4;
        font-weight: bold;
        line-height: 120%;
        color: rgba(34, 34, 34, 1);
        position: relative;
        left: -50%;
        transform: translate(50%, -50%);
    }

    .center>>>p {
        font-size: 16px;
        font-weight: bold;
        line-height: 28px;
        color: rgba(112, 112, 112, 1);
    }

    .imgbox {
        height: 23.9vw;
        width: 90%;
        background: #666666 no-repeat center center;
        background-size: cover;
        transform: translateY(59px);
    }

    .imglogo-box {
        height: 94px;
        width: 344px;
        background: #ffffff no-repeat center center;
        background-size: cover;
    }

    .right-center {
        max-width: 565px;
        font-size: 24px;
        font-weight: 400;
        line-height: 175%;
        color: rgba(102, 102, 102, 1);
        margin: 26px 0 63px 0;
    }

    .right-ul {
        display: flex;
        width: 100%;
        justify-content: space-between;
    }

    .right-li {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }

    .number {
        font-size: 32px;
        font-weight: bold;
        line-height: 80px;
        color: rgba(36, 136, 248, 1);
    }

    .numbertitle {
        width: 90px;
        text-align: center;
        font-size: 16px;
        font-weight: 400;
        color: rgba(255, 255, 255, 1);
        background-color: #2488F8;
    }

    .itemright {
        display: flex;
        flex-direction: column;
        justify-content: flex-end;
        align-items: center;
        padding-bottom: 86px;
    }

    /* 线条运动 */
    @keyframes linearMotion {
        from {
            right: 150%;
        }

        to {
            right: -52%;
        }
    }

    @media(max-width: 1364px){
    .number {
        font-size: 24px;
        line-height: 250%;
    }

    .numbertitle {
        width: 90px;
        text-align: center;
        font-size: 16px;
        font-weight: 400;
        color: rgba(255, 255, 255, 1);
        background-color: #2488F8;
    }
    }
    @media(max-width: 1300px){
        .center-box {
        grid-template-columns:45% 45%;
        grid-column-gap:10%;
    }
    }
    @media(max-width: 995px){
        .socialmedia-box {
        margin:10% 0;
    }
        .center-box {
            display: grid;
            grid-template-columns: 1fr;
            grid-column-gap: 0;
            width: 100%;
            padding: 5%;
        }
        .caption {
        font-size: 7.291vw;
        line-height: 120%;
        position: static;
        transform: translate(0%, 0%);
        margin-bottom: 5%;
    }
        .imgbox {
        margin-top: 5%;
        height: 40.2vw;
        width: 80%;
        background: #666666 no-repeat center;
        background-size: cover;
        transform: translateY(0px);
    }
    .center{
        align-self: center;
    }
    .itemright {
        padding-bottom:0%;
    }
    .imglogo-box {
        height: 9.44vw;
        width: 34.57vw;
        margin-top: 10%;
    }
    .right-center {
        max-width:100%;
        font-size: 16px;
        margin:0;
    }
    }

    /* @media(max-width: 1023px) {
        .socialmedia-box {
            margin-bottom: 0;
        }

        .center-box {
            display: grid;
            grid-template-columns: 1fr;
            grid-column-gap: 0;
            width: 100%;
            padding: 0 5%;
        }

        .center>>>p {
            font-size: 50px;
            line-height: 175%;
        }

        .imgbox {
            margin-top: 5%;
            height: 1000px;
            width: 100%;
            background: #666666 no-repeat center;
            background-size: cover;
            transform: translateY(0px);
        }

        .imglogo-box {
            margin-top: 5%;
            height: 150px;
            width: 50%;
        }

        .right-center {
            max-width: 90%;
            font-size: 50px;
            line-height: 175%;
        }

        .right-ul {
            width: 80%;
        }

        .number {
            font-size: 70px;
            line-height: 250%;
        }

        .numbertitle {
            width: auto;
            text-align: center;
            padding: 0 5%;
            white-space: nowrap;
            font-size: 50px;
        }
    } */
</style>


// WEBPACK FOOTER //
// src/components/main/project/socialmedia.vue